import classNames from 'classnames';
import styles from './styles.module.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LocationService } from 'services';
import Icons from '../../icons';

const locationSrv = new LocationService();

type TabsHeaderPropsType = {
  tabIndex: number;
  setTabIndex: (index: number) => void;
  activeCount: number;
  inActiveCount: number;
};

const TabsHeader = (props: TabsHeaderPropsType) => {
  const { tabIndex, setTabIndex, activeCount, inActiveCount } = props;
  const history = useHistory();
  const location = useLocation();
  locationSrv.setLocation(location);
  const { status } = locationSrv.getQuery();

  useEffect(() => {
    if (!status || !['active', 'inactive'].includes(status)) {
      history.push(locationSrv.setQuery({ status: 'active' }));
      setTabIndex(0);
    } else setTabIndex(status === 'active' ? 0 : 1);
  }, []);

  const getVendorTabs = () => {
    return [
      {
        label: `Active${activeCount ? ` (${activeCount})` : ''}`,
        icon: <Icons variant={Icons.PROMO} color={tabIndex === 0 ? '#FF576D' : '#747475'} />,
      },
      {
        label: `Inactive${inActiveCount ? ` (${inActiveCount})` : ''}`,
        icon: <Icons variant={Icons.ARCHIVE} color={tabIndex === 1 ? '#FF576D' : '#747475'} />,
      },
    ];
  };

  const handleTabClick = (index) => {
    setTabIndex(index);

    switch (index) {
      case 0:
        history.push(locationSrv.setQuery({ status: 'active' }));
        break;
      case 1:
        history.push(locationSrv.setQuery({ status: 'inactive' }));
        break;
      default:
        history.push(locationSrv.setQuery({ status: 'active' }));
    }
  };

  return (
    <div className={styles.tabsHeader}>
      {getVendorTabs().map((tab, index) => (
        <div
          className={classNames(styles.tab, tabIndex === index ? styles.tabActive : undefined)}
          onClick={() => handleTabClick(index)}
        >
          {tab.icon}
          <span
            className={classNames(
              styles.tabLabel,
              tabIndex === index ? styles.tabLabelActive : undefined,
            )}
          >
            {tab.label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TabsHeader;
